/**
 * i18n configuration for Refinevoice UI
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
// Import translation files
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  nl: { translation: nl },
  pl: { translation: pl },
  ru: { translation: ru },
  ja: { translation: ja },
  ko: { translation: ko },
  zh: { translation: zh },
};

// Load initial UI language from localStorage
const loadInitialUILanguage = (): string => {
  try {
    const stored = localStorage.getItem('refinevoice_ui_language');
    if (stored) {
      const languageCode = JSON.parse(stored);
      // Check if this language code is supported in our i18n resources
      if (resources[languageCode as keyof typeof resources]) {
        return languageCode;
      }
    }
  } catch (error) {
    console.error('Failed to load UI language from localStorage:', error);
  }
  return 'en'; // Default to English
};

i18n.use(initReactI18next).init({
  resources,
  lng: loadInitialUILanguage(), // Load from localStorage
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false, // React already escapes
  },

  debug: false, // Set to true for development debugging
});

export default i18n;
